import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import LayerSelectionCard from '../../Cards/LayerSelectionCard';
import DashboardCard from '../../Cards/DashboardCard.component';
import { useEffect, useState } from 'react';
import React from 'react';
import useTranslation from '../../Language/useTranslation';
import DroneDataYearDisplay from './DroneDataYearDisplay';
import { set } from 'lodash';
import { DroneLayersList } from '../../../Services/apiResponseInterfaces';
import { useUserSelection } from '../../../Contexts/useUserSelection';
import useFilteredDroneLayers from '../../../Hooks/useFilterDroneDataByYear';

interface DroneContentProps {
    droneLayerList: any[],
    selectedLayer: string | null,
    setSelectedLayer: React.Dispatch<React.SetStateAction<string | null>>,
    droneLoading: boolean,
    setFilteredDroneLayerList: React.Dispatch<React.SetStateAction<DroneLayersList[]>>,
    filteredDroneLayerList: DroneLayersList[],
}

/**
 * Contains all elements in the Drone Tab.
 */

function DroneContent({ droneLayerList, selectedLayer, setSelectedLayer, droneLoading, setFilteredDroneLayerList, filteredDroneLayerList }: DroneContentProps) {
    const t = useTranslation();
    const { selectedYear, setSelectedYear } = useUserSelection();
    // const [filteredDroneLayerList, setFilteredDroneLayerList] = useState<any[]>([]);

    useEffect(() => {
        if (selectedLayer === "") {
            setSelectedLayer("uav_orthophoto");
        }
    }, [selectedLayer, setSelectedLayer]);

    useEffect(() => {
        if (droneLayerList.length > 0) {
            const allYears = droneLayerList.flatMap(layer =>
                layer.layers.map((subLayer: any) => new Date(subLayer.date_str).getFullYear())
            );
            const maxYear = Math.max(...allYears);
            setSelectedYear(maxYear);
        }
    }, [droneLayerList, setSelectedYear]);


    useFilteredDroneLayers({ droneLayerList, setFilteredDroneLayerList });


    if (droneLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!droneLayerList || droneLayerList.length === 0) {
        return (
            <Typography variant="h6">
                {t.noData}
            </Typography>
        );
    }


    console.log("filtered DL", filteredDroneLayerList)
    const displayList = filteredDroneLayerList.length > 0 ? filteredDroneLayerList : droneLayerList;


    // Funktion zum Extrahieren der Anzahl der Ebenen pro Jahr
    const getYearlyLayerCounts = (layers: any[]) => {
        const yearCounts: { [year: string]: number } = {};

        layers.forEach(layer => {
            layer.layers.forEach((subLayer: any) => {
                const year = new Date(subLayer.date_str).getFullYear();
                if (yearCounts[year]) {
                    yearCounts[year]++;
                } else {
                    yearCounts[year] = 1;
                }
            });
        });

        const years = Object.keys(yearCounts).map(year => parseInt(year)).sort((a, b) => a - b);
        const result = [];
        for (let year = years[0]; year <= years[years.length - 1]; year++) {
            result.push({ year, count: yearCounts[year] || 0 });
        }

        return result;
    };

    const yearlyLayerCountsList = getYearlyLayerCounts(droneLayerList);

    console.log("droneLayerList: ", droneLayerList);
    console.log("yearlyLayerCounts: ", yearlyLayerCountsList);



    return (
        <Box>
            {/* Keep DroneDataYearDisplay inside parent container with fixed height */}
            <Box sx={{
                display: 'flex', alignItems: 'center', height: '80px', mb: 2
            }}>
                <DroneDataYearDisplay
                    yearlyCountsList={yearlyLayerCountsList}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear} />
            </Box>

            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                {displayList.map((droneLayer, index) => (
                    <Stack key={index} direction="column" spacing={2} mt={1}>
                        {console.log("DroneContent: ", droneLayer)}
                        <Grid item sx={{ width: 300, mr: 2 }}>
                            <LayerSelectionCard
                                datasetId={droneLayer.dataset_id}
                                name={droneLayer.name}
                                selectedLayer={selectedLayer}
                                setSelectedLayer={setSelectedLayer}
                                layerType={droneLayer.layer_type}
                                imgLink={droneLayer.img_link}
                                layerDescription={droneLayer.description}
                                withDate={true}
                                date={droneLayer.layers?.[0]?.date_str}
                            />
                        </Grid>
                        <Grid item sx={{ width: 300, mr: 2 }}>
                            <DashboardCard
                                description={droneLayer?.layers?.[0]?.statistics?.[0]?.description}
                                number={droneLayer?.layers?.[0]?.statistics?.[0]?.text_value}
                                height='100px'
                            />
                        </Grid>
                    </Stack>
                ))}
            </Grid>
        </Box>
    );
}

export default React.memo(DroneContent);